import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";

const PhoneInput = ({ phoneNumber, name, setName, setPhoneNumber, setPageVisible, form, setForm, setloggedIn }) => {
  const [enteredOTP, setEnteredOTP] = useState('');
  const [generatedOTP, setGeneratedOTP] = useState('');
  const [verificationStatus, setVerificationStatus] = useState('');
  const [showOTPInput, setShowOTPInput] = useState(false);

  const handleOTP = () => {
    // Generate a random 6-digit OTP
    const otp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOTP(otp);
    setShowOTPInput(true);
    setVerificationStatus('');
    console.log("Generated OTP:", otp);
  };

  const handleVerification = () => {
    if (enteredOTP === generatedOTP) {
      setVerificationStatus('verified');
      
      setTimeout(() => {
        setloggedIn(true);
        setShowOTPInput(false);
      }, 2000);
    } else {
      setVerificationStatus('failed');
    }
  };

  return (
    <div id="verify" tabIndex="5" className="mt-1 d-md-block mx-auto d-block container view justify-content-center d-flex " style={{ position: 'absolute', fontSize: "18px", zIndex: '1500' }}>
      <div className='row '>
        <div className="card mx-auto col-sm-12 col-lg-12 col-md-6" style={{ maxWidth: "400px" }}>
          <div className='px-2 pb-0 ' style={{ position: 'absolute', right: '10px' }}>
            <span><IoClose onClick={() => setPageVisible(false)} /></span>
          </div>
          <div className="card-body view ">
            <h3 className="card-title text-center mb-4 mt-4">Login With Phone</h3>

            {!showOTPInput ? (
              <form>
                <div className='mb-3'>
                  <input
                    type="text"
                    className='form-control'
                    placeholder="Enter your Name"
                    value={form.name || name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Phone Number"
                    value={phoneNumber || form.phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  onClick={handleOTP}
                  className="btn btn-primary btn-block"
                >
                  Get OTP
                </button>
              </form>
            ) : (
              <div>
                {/* Show OTP directly in UI for testing */}
                <p className="text-info">Test OTP: <strong>{generatedOTP}</strong></p>

                <div className="mb-3">
                  <input
                    type="text"
                    value={enteredOTP}
                    onChange={(e) => setEnteredOTP(e.target.value)}
                    className="form-control"
                    placeholder="Enter OTP"
                  />
                </div>
                <button onClick={handleVerification} className="btn btn-primary">Verify OTP</button>

                {verificationStatus === 'verified' && <p className="text-success mt-3">OTP Verified. Redirecting to main page...</p>}
                {verificationStatus === 'failed' && <p className="text-danger mt-3">Incorrect OTP. Please try again.</p>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;
